<script>
import BasePanel from '@/components/default/views/shared/BasePanel'
import { mapGetters } from 'vuex'

export default {
	name: 'ControlPanel',
	props: { 'enrollmentList': Array },
	components: {
		BasePanel
	},
	data: () => ({
		loading: false
	}),
	methods: {
		createEnrollment: function () {
			this.loading = true
			this.$router.push({	name: 'enrollment' })
		}
	},
	computed: {
		enrollmentsInProgress: function () {
			return this.enrollmentList.filter(e => (e.status === 'IN_PROGRESS' || e.status === 'NEW')).length
		},
		enrollmentsCompleted: function () {
			return this.enrollmentList.filter(e => e.status === 'COMPLETE').length
		},
		...mapGetters(['employee'])
	}
}
</script>

<template>
	<base-panel>
		<h1 class="control-panel__title" slot="header">{{ $t("dashboard.dashboard") }}</h1>
		<div class="control-panel__stats--progress" slot="information">
			<h3 class="control-panel__label">{{ $t("dashboard.inProgress") }}</h3>
			<p class="control-panel__counter">{{ enrollmentsInProgress }}</p>
		</div>
		<div class="control-panel__stats--completed" slot="information">
			<h3 class="control-panel__label">{{ $t("dashboard.completed") }}</h3>
			<p class="control-panel__counter">{{ enrollmentsCompleted }}</p>
		</div>
		<base-button modifiers="primary mobile-width" @click.native="createEnrollment()" slot="actions">{{ $t("dashboard.newEnrollment") }}</base-button>
	</base-panel>
</template>

<style lang="scss">
	.control-panel {
		&__title {
			font-size: 2rem;
			font-weight: bold;
		}
		&__stats {
			&--progress {
				padding: 0.5rem 1rem 0.5rem 0;
			}
			&--completed {
				padding: 0.5rem 0 0.5rem 0;
			}
		}
		&__label {
			color: var(--panel-secondary-colour);
			font-size: 1.25rem;
			@media (max-width: 600px) {
				font-size: 1rem;
			}
		}
		&__counter {
			font-size: 2.5rem;
			font-weight: bold;
			@media (max-width: 600px) {
				font-size: 2rem;
			}
		}
	}
</style>
